import { render, staticRenderFns } from "./AdressListItem.vue?vue&type=template&id=ae9a3248&"
import script from "./AdressListItem.vue?vue&type=script&lang=js&"
export * from "./AdressListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdressListItem.vue"
export default component.exports